// extracted by mini-css-extract-plugin
export default {"fieldLabelReadonly":"common-configurable-wizards-fields-NewUsername-UsernameField__fieldLabelReadonly--HkT6-"};